export default {
  'pages.productDetail.home': 'Home',
  'pages.productDetail.addCart': 'add cart',
  'pages.productComDetail.addCart': 'add cart',
  'pages.productDetail.interestedDesc':
    'If you are interested in the product or want to quickly learn more, please click on',
  'pages.productDetail.onlineService': 'online service',
  'pages.productDetail.selectDesc': 'Please select the required process',
  'pages.productDetail.selectMaterial': 'Please select the required material',
  'pages.productDetail.down1': 'Download Printing Area Instructions',
  'pages.productDetail.down2': 'Download Explosion Diagram',
  'pages.productDetail.collapse1': 'Product Details',
  'pages.productDetail.collapse2': 'Material Information',
  'pages.productDetail.collapse3': 'Purchasing Process',
  'pages.productDetail.collapse4': 'Purchasing instructions',
  'pages.productDetail.signTitle': 'Would you like to see more? ',
  'pages.productDetail.signSubTitle':
    'Please sign in for detailed information.',
  'pages.productDetail.signBtn': 'Sign In',
};
